import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-lg-8" }
const _hoisted_5 = { class: "card shadow" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12 text-right" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "col-12 col-lg-4" }
const _hoisted_13 = { class: "card shadow" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = {
  key: 0,
  class: "col-12"
}
const _hoisted_18 = {
  key: 1,
  class: "col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_intervals = _resolveComponent("intervals")
  const _component_parity = _resolveComponent("parity")
  const _component_TradeChart = _resolveComponent("TradeChart")
  const _component_trade_options = _resolveComponent("trade-options")
  const _component_AdvanceTransaction = _resolveComponent("AdvanceTransaction")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_intervals, {
                  onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.interval = $event.id))
                }),
                _createVNode(_component_parity, {
                  onUpdate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onParityUpdate($event)))
                })
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                (_ctx.parity.cripto)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode(_component_TradeChart, {
                        criptoCurrency: _ctx.parity.cripto,
                        localCurrency: _ctx.parity.local,
                        interval: _ctx.interval
                      }, null, 8, ["criptoCurrency", "localCurrency", "interval"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode(_component_trade_options, {
                  onUpdate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onTradeOptionUpdate($event)))
                })
              ]),
              (_ctx.currencyValues.btc)
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _createVNode(_component_AdvanceTransaction, {
                      type: "BUY",
                      parity: {local: _ctx.parity.local, cripto: _ctx.parity.cripto},
                      currencyValues: _ctx.currencyValues,
                      key: _ctx.parity+Math.floor((Math.random() * 100) + 1),
                      tradeType: _ctx.tradeType
                    }, null, 8, ["parity", "currencyValues", "tradeType"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currencyValues.btc)
                ? (_openBlock(), _createBlock("div", _hoisted_18, [
                    _createVNode(_component_AdvanceTransaction, {
                      type: "SELL",
                      parity: {local: _ctx.parity.local, cripto: _ctx.parity.cripto},
                      currencyValues: _ctx.currencyValues,
                      key: _ctx.parity+Math.floor((Math.random() * 100) + 1),
                      tradeType: _ctx.tradeType
                    }, null, 8, ["parity", "currencyValues", "tradeType"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}